export enum CacheKeyEnum {
  mainToken = "b2c-cms-token",
  storeList = "b2c-store-list",
  mobilePackage = "b2c-mobile-package",
  nationListForFilter = "b2c-nation-list",
  simMobilePlanPakage = "b2c-sim-mobile-package",
  inboundPakcage = "b2c-inbound-package",
  serviceList = "b2c-service-list",
  partnerList = "b2c-partner-list",
  internalFeature = "b2c-features",
  simEcommercePackage = "b2c-sim-ecommerce-package",
  carrierList = "b2c-carrier-list",
  modalErrorCode = "b2c-modal-error-code",
  userStore = "b2c-user-store",
  b2cPartner = "b2c-b2c-partner",
  userChain = "b2c-user-chain",
  carrierForPackage = "b2c-carrier-for-package",
  categoryListForPackage = "b2c-category-for-package",
  capabilities = "b2c-service-capabilities",
  userMenu = "b2c-user-menu",
  filterMenu = "b2c-menu-for-filter",
  user = "b2c-user-info",
  zodiac = "b2c-zodiac-list",
  destiny = "b2c-destiny-list",
  numerology = "b2c-numerology-list",
  provider = "b2c-provider-list",
  partnerOfUser = "b2c-partner-of-user",
  language = "b2c-language",
  transExport = "transaction.export",
  cashFlowExport = "cashflow.export",
  isSavedForNextLogin = "b2c-isSavedForNextLogin",
}
